<template>
	<div class="register">
		<div class="header">
			<div class="header-title" @click="handleFallback">
				<i class="iconfont fallback">&#xe613;</i>数据登记
			</div>
			<div class="header-select">
		    	<awesome-picker
			      	ref="selectRegisterPicker"
			      	:textTitle="registerPicker.textTitle"
			      	:anchor="registerPicker.anchor"
			      	:type="registerPicker.type"
			      	@confirm="handleSelectRegister"
			    >
			    </awesome-picker>
			    <div class="select-wrapper" @click="registerSelectShow">
			    	<span class="icon-wrapper">
			    		<i class="iconfont select-icon">&#xe60e;</i>
			    	</span>
			    	<span class="select">
			    		{{currentDate}}
			    	</span>
		    	</div>
			</div>
		</div>
		<table border="1" class="content-list">
				<thead>
					<tr>
						<th>渠道</th>
						<th>消费</th>
						<th>对话</th>
						<th>到诊</th>
						<th>确诊对话</th>
					</tr>
				</thead>
				<tbody>
						<tr>
							<td>竞价</td>
							<td>{{jj_cost_price}}</td>
							<td>{{jj_dialog_count}}</td>
							<td>{{jj_in_count}}</td>
							<td>{{jj_sure_count}}</td>
						</tr>
						<tr>
							<td>优化</td>
							<td>{{yh_cost_price}}</td>
							<td>{{yh_dialog_count}}</td>
							<td>{{yh_in_count}}</td>
							<td>{{yh_sure_count}}</td>
						</tr>
						<tr>
							<td>门户</td>
							<td>{{mh_cost_price}}</td>
							<td>{{mh_dialog_count}}</td>
							<td>{{mh_in_count}}</td>
							<td>{{mh_sure_count}}</td>
						</tr>
						<tr>
							<td>新媒体</td>
							<td>{{xmt_cost_price}}</td>
							<td>{{xmt_dialog_count}}</td>
							<td>{{xmt_in_count}}</td>
							<td>{{xmt_sure_count}}</td>
						</tr>
						<tr>
							<td>资源合作</td>
							<td>{{zyhz_cost_price}}</td>
							<td>{{zyhz_dialog_count}}</td>
							<td>{{zyhz_in_count}}</td>
							<td>{{zyhz_sure_count}}</td>
						</tr>
						<tr>
							<td>无轨迹</td>
							<td>{{wgj_cost_price}}</td>
							<td>{{wgj_dialog_count}}</td>
							<td>{{wgj_in_count}}</td>
							<td>{{wgj_sure_count}}</td>
						</tr>
						<tr>
							<td>其他</td>
							<td>{{qt_cost_price}}</td>
							<td>{{qt_dialog_count}}</td>
							<td>{{qt_in_count}}</td>
							<td>{{qt_sure_count}}</td>
						</tr>
				</tbody>
		</table>
		<!-- <div class="confirm-link" @click="handleResisteSubmit">确定</div> -->
	</div>
</template>

<script>
	import BScroll from 'better-scroll'
	import axios from 'axios'
	import {getDates} from '@/assets/js/_mm.js'
	import {
		fallback,
		computedCost,
		validate,
		getCurrentTime,
		getDay
	} from '@/assets/js/_mm.js'
	export default {
		name: 'PlanHome',
		props: {
			selectDate: String,
			type: String
		},
		data () {
			return {
				registerPicker: {
					textTitle: '月份选择',
					anchor: [],
					type: 'date'
				},
				currentDate : (() => {
					return this.selectDate || getDay(-1, '-')
				})(),
				// 竞价
				jj_in_count: '',
				jj_dialog_count: '',
				jj_sure_count: '',
				jj_cost_price: '',

				// 优化
				yh_in_count: '',
				yh_dialog_count: '',
				yh_sure_count: '',
				yh_cost_price: '',
				// 门户
				mh_in_count: '',
				mh_dialog_count: '',
				mh_sure_count: '',
				mh_cost_price: '',
				// 新媒体
				xmt_in_count: '',
				xmt_dialog_count: '',
				xmt_sure_count: '',
				xmt_cost_price: '',
				// 资源合作
				zyhz_in_count: '',
				zyhz_dialog_count: '',
				zyhz_sure_count: '',
				zyhz_cost_price: '',
				// 无轨迹
				wgj_in_count: '',
				wgj_dialog_count: '',
				wgj_sure_count: '',
				wgj_cost_price: '',
				// 其他
				qt_in_count: '',
				qt_dialog_count: '',
				qt_sure_count: '',
				qt_cost_price: ''
			}
		},
		methods: {
			registerSelectShow () {
				this.$refs.selectRegisterPicker.show()
			},
			handleSelectRegister (e) {
				let y = e[0]['value'].replace(/[^\d]/g,'')
				let m = e[1]['value'].replace(/[^\d]/g,'')
				let d = e[2]['value'].replace(/[^\d]/g,'')
				this.currentDate = y + '-' + m + '-' + d
				this.registerPicker.anchor = e
				this.getDayPlan()
			},
			handleFallback () {
				this.$router.go(-1)
			},
			getDayPlan () {
				axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Sel_day_plan',
						hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
						time: this.currentDate
					}
				}).then((res) => {
					let result = res.data
					if(result.ret && result.ret === 200) {
						let data = result.data
						if(Object.keys(data).length > 0){
							// 竞价
							this.jj_in_count = data.jj_in_count
							this.jj_dialog_count = data.jj_dialog_count
							this.jj_sure_count = data.jj_sure_count
							this.jj_cost_price = parseInt(data.jj_cost_price)
							// 优化
							this.yh_in_count = data.yh_in_count
							this.yh_dialog_count = data.yh_dialog_count
							this.yh_sure_count = data.yh_sure_count
							this.yh_cost_price = parseInt(data.yh_cost_price)
							// 门户
							this.mh_in_count = data.mh_in_count
							this.mh_dialog_count = data.mh_dialog_count
							this.mh_sure_count = data.mh_sure_count
							this.mh_cost_price = parseInt(data.mh_cost_price)
							// 新媒体
							this.xmt_in_count = data.xmt_in_count
							this.xmt_dialog_count = data.xmt_dialog_count
							this.xmt_sure_count = data.xmt_sure_count
							this.xmt_cost_price = parseInt(data.xmt_cost_price)
							// 资源合作
							this.zyhz_in_count = data.zyhz_in_count
							this.zyhz_dialog_count = data.zyhz_dialog_count
							this.zyhz_sure_count = data.zyhz_sure_count
							this.zyhz_cost_price = parseInt(data.zyhz_cost_price)

							// 无轨迹
							this.wgj_in_count = data.wgj_in_count
							this.wgj_dialog_count = data.wgj_dialog_count
							this.wgj_sure_count = data.wgj_sure_count
							this.wgj_cost_price = parseInt(data.wgj_cost_price)

							// 其他
							this.qt_in_count = data.qt_in_count
							this.qt_dialog_count = data.qt_dialog_count
							this.qt_sure_count = data.qt_sure_count
							this.qt_cost_price = parseInt(data.qt_cost_price)
						} else {
							// 竞价
							this.jj_in_count = ''
							this.jj_dialog_count = ''
							this.jj_cost_price = ''
							// 优化
							this.yh_in_count = ''
							this.yh_dialog_count = ''
							this.yh_cost_price = ''
							// 门户
							this.mh_in_count = ''
							this.mh_dialog_count = ''
							this.mh_cost_price = ''
							// 新媒体
							this.xmt_in_count = ''
							this.xmt_dialog_count = ''
							this.xmt_cost_price = ''
							// 资源合作
							this.zyhz_in_count = ''
							this.zyhz_dialog_count = ''
							this.zyhz_cost_price = ''
							// 无轨迹
							this.wgj_in_count = ''
							this.wgj_dialog_count = ''
							this.wgj_cost_price = ''

							// 其他
							this.qt_in_count = ''
							this.qt_dialog_count = ''
							this.qt_cost_price = ''
						}
					}
				})
			},
			defPicker () {
				let y = this.currentDate.split('-')[0] + '年'
				let m = this.currentDate.split('-')[1].replace(/^0/,'') + '月'
				let d = this.currentDate.split('-')[2] + '日'
				this.registerPicker.anchor	= [
					{value: y},
					{value: m},
					{value: d}
				]
			}
		},
		mounted () {
			this.getDayPlan()
			this.defPicker()
		}
	}
</script>

<style lang="stylus" scoped>
	.register
		background-color: #fff
		&::after
			content: ""
			display: table
		.header
			display: flex
			justify-content: space-between
			height: 1.1rem
			padding: 0 .2rem 0 .4rem
			background-color: #fff
			margin-bottom:5px
			.header-title
				line-height: 1.1rem
				color: #1d1d1d
				font-size: .32rem
				.fallback
					vertical-align: middle;
					font-size: .42rem
					margin-right: .12rem
					font-weight: bold;
			.header-select
				line-height: 1.2
				.select-wrapper
					display: inline-block
					font-size: 0
					color: #0099ff
					.icon-wrapper
						display: inline-block
						vertical-align: top;
						.iconfont
							font-size: .48rem
				.select
					display: inline-block
					vertical-align: top;
					width: 2rem
					margin-top: 0.1rem
					font-size: .32rem
					text-align: center
		.content-list
			width: 100%
			thead th
				text-align: center
				padding: 10px
			thead th:first-child
				text-align: left
			tbody td
				padding: 10px
</style>



// WEBPACK FOOTER //
// src/pages/register/Register.vue